import { MapContext } from '@context/MapProvider';
import { useContext } from 'react';

const useMapContext =()=> {
	const {contextData, setContextData} = useContext(MapContext);
	return [contextData, setContextData];
}

export default useMapContext;